module.exports = __webpack_public_path__ + "static/media/vector-icons-feedback.0afa9b45.svg";